<template>
  <v-form ref="form" v-model="valid">
    <v-card class="pa-3">
      <v-card-text>
            <v-layout align-center class="green--text mb-4">
              <h3>Adicionar Actividade</h3>
            </v-layout>
        <v-flex xs12>
          <span class="caption grey--text text--darken-1">Tipo</span>
          <v-select
            v-model="formData.otherActivityType"
            :items="otherActivityTypes || []"
            solo
            class="thin-border"
          />

          <div v-if="postGraduateTrainingIsSelected">
            <v-layout align-center class="green--text mb-2">
              <h3 ref="title">Formação Pós-graduada</h3>
            </v-layout>

            <v-select
              v-model="formData.otherActivitySubType"
              label="Tipo"
              :items="postGraduateTrainingTypes || []"
              solo
              class="thin-border"
            />

            <div
              v-if="formData.otherActivitySubType === 'doctoralProgram'"
              class="ml-2"
            >
              <p ref="title">
                <b>Programa de Doutoramento</b>
              </p>

              <span class="caption grey--text text--darken-1">Título</span>
              <v-text-field
                v-model="formData.title"
                type="text"
                label="Título"
                solo
                class="thin-border mb-2"
                hide-details
              />

              <span class="caption grey--text text--darken-1">Orientador</span>
              <v-text-field
                v-model="formData.advisor"
                type="text"
                label="Orientador"
                solo
                class="thin-border mb-2"
                hide-details
              />

              <span class="caption grey--text text--darken-1">Instituição</span>
              <v-text-field
                v-model="formData.institution"
                type="text"
                solo
                class="thin-border mb-2"
                hide-details
              />

              <p class="mb-2">
                <b>Resumo</b>
              </p>

              <file-upload
                :file-url-uploaded.sync="formData.fileUrlAttached"
                :file-name-uploaded.sync="formData.fileNameAttached"
                :path-to-files="filepath"
              ></file-upload>
            </div>

            <div
              v-if="formData.otherActivitySubType === 'graduateCourse'"
              class="ml-2"
            >
              <p ref="title" class="mt-4">
                <b>Curso de Pós-Graduação</b>
              </p>

              <v-text-field
                v-model="formData.title"
                type="text"
                label="Título"
              />

              <v-text-field
                v-model="formData.institution"
                type="text"
                label="Instituição"
              />

              <v-text-field
                v-model="formData.duration"
                type="number"
                label="Duração (horas)"
              />

              <v-text-field
                v-model="formData.ects"
                type="number"
                label="Nº ECTS"
              />

              <DatePickerPopUp
                label="Data inicío"
                v-model="formData.startDate"
              />

              <DatePickerPopUp label="Data fim" v-model="formData.endDate" />

              <p>
                <b>Certificado</b>
              </p>

              <file-upload
                :file-url-uploaded.sync="formData.fileUrlAttached"
                :file-name-uploaded.sync="formData.fileNameAttached"
                :path-to-files="filepath"
              ></file-upload>
            </div>

            <div
              v-if="formData.otherActivitySubType === 'masterProgram'"
              class="ml-2"
            >
              <p ref="title" class="mt-4">
                <b>Programa de Mestrado</b>
              </p>

              <v-text-field
                v-model="formData.title"
                type="text"
                label="Título"
              />

              <v-text-field
                v-model="formData.promotingInstitution"
                type="text"
                label="Instituição promotora"
              />

              <v-text-field
                v-model="formData.duration"
                type="number"
                label="Duração (horas)"
              />

              <v-text-field
                v-model="formData.ects"
                type="number"
                label="Nº ECTS"
              />

              <DatePickerPopUp
                label="Data inicío"
                v-model="formData.startDate"
              />

              <DatePickerPopUp label="Data fim" v-model="formData.endDate" />

              <p class="mb-2">
                <b>Resumo</b>
              </p>

              <file-upload
                :file-url-uploaded.sync="formData.fileUrlAttached"
                :file-name-uploaded.sync="formData.fileNameAttached"
                :path-to-files="filepath"
              ></file-upload>
            </div>
          </div>

          <div v-if="researchActivitiesIsSelected">
            <v-layout align-center class="green--text mb-2">
              <h3 ref="title">Actividades de Investigação</h3>
            </v-layout>

            <v-select
              v-model="formData.otherActivitySubType"
              label="Tipo de Investigação"
              :items="researchActivitiesTypes || []"
              solo
              class="thin-border"
            />

            <div
              v-if="formData.otherActivitySubType === 'observationalResearch'"
              class="ml-2"
            >
              <p ref="title">
                <b>Investigação Observacional</b>
              </p>
              <span class="caption grey--text text--darken-1">Título</span>
              <v-text-field
                v-model="formData.title"
                type="text"
                solo
                hide-details
                class="thin-border mb-2"
              />
              <span class="caption grey--text text--darken-1">Promotor</span>
              <v-text-field
                v-model="formData.promotor"
                type="text"
                solo
                hide-details
                class="thin-border mb-2"
              />

              <span class="caption grey--text text--darken-1">Investigador Principal</span>
              <v-text-field
                v-model="formData.principalInvestigator"
                type="text"
                solo
                class="thin-border"
              />

              <DatePickerPopUp
                label="Data inicío"
                v-model="formData.startDate"
              />

              <DatePickerPopUp label="Data fim" v-model="formData.endDate" />

              <p class="mb-2">
                <b>Resumo</b>
              </p>

              <v-text-field
                v-model="formData.summary"
                type="text"
                label="Resumo"
                solo
                class="thin-border"
              />

              <file-upload
                :file-url-uploaded.sync="formData.fileUrlAttached"
                :file-name-uploaded.sync="formData.fileNameAttached"
                :path-to-files="filepath"
              ></file-upload>
            </div>

            <div
              v-if="formData.otherActivitySubType === 'experimentalResearch'"
              class="ml-2"
            >
              <p ref="title" class="mt-4">
                <b>Investigação Experimental</b>
              </p>

              <v-select
                v-model="formData.experimentalResearchType"
                label="Tipo"
                :items="experimentalResearchTypes || []"
              />

              <div
                v-if="formData.experimentalResearchType === 'certificates'"
                class="ml-2"
              >
                <p ref="title">
                  <b>Certificados</b>
                </p>

                <v-text-field
                  v-model="formData.title"
                  type="text"
                  label="Título"
                />

                <v-text-field
                  v-model="formData.institution"
                  type="text"
                  label="Instituição"
                />

                <DatePickerPopUp
                  label="Data inicío"
                  v-model="formData.startDate"
                />

                <DatePickerPopUp label="Data fim" v-model="formData.endDate" />

                <file-upload
                  :file-url-uploaded.sync="formData.fileUrlAttached"
                  :file-name-uploaded.sync="formData.fileNameAttached"
                  :path-to-files="filepath"
                ></file-upload>
              </div>

              <div
                v-if="
                  formData.experimentalResearchType === 'clinicalTrialDesign'
                "
                class="ml-2"
              >
                <p ref="title" class="mt-4">
                  <b>Desenho de Ensaios Clínicos</b>
                </p>

                <v-text-field
                  v-model="formData.title"
                  type="text"
                  label="Título"
                />

                <v-text-field
                  v-model="formData.promotor"
                  type="text"
                  label="Promotor"
                />

                <v-text-field
                  v-model="formData.principalInvestigator"
                  type="text"
                  label="Investigador Principal"
                />

                <DatePickerPopUp
                  label="Data inicío"
                  v-model="formData.startDate"
                />

                <DatePickerPopUp label="Data fim" v-model="formData.endDate" />

                <v-text-field
                  v-model="formData.summary"
                  type="text"
                  label="Resumo"
                />

                <p class="mb-2">
                  <b>Resumo</b>
                </p>

                <file-upload
                  :file-url-uploaded.sync="formData.fileUrlAttached"
                  :file-name-uploaded.sync="formData.fileNameAttached"
                  :path-to-files="filepath"
                ></file-upload>
              </div>

              <div
                v-if="
                  formData.experimentalResearchType ===
                  'participationInClinicalTrials'
                "
                class="ml-2"
              >
                <p ref="title" class="mt-4">
                  <b>Participação em Ensaios Clínicos</b>
                </p>

                <v-text-field
                  v-model="formData.title"
                  type="text"
                  label="Título"
                />

                <v-text-field
                  v-model="formData.clinicalId"
                  type="text"
                  label="ID"
                />

                <v-text-field
                  v-model="formData.principalInvestigator"
                  type="text"
                  label="Investigador Principal"
                />

                <DatePickerPopUp
                  label="Data inicío"
                  v-model="formData.startDate"
                />

                <DatePickerPopUp label="Data fim" v-model="formData.endDate" />

                <v-text-field
                  v-model="formData.summary"
                  type="text"
                  label="Resumo"
                />

                <p class="mb-2">
                  <b>Resumo</b>
                </p>

                <file-upload
                  :file-url-uploaded.sync="formData.fileUrlAttached"
                  :file-name-uploaded.sync="formData.fileNameAttached"
                  :path-to-files="filepath"
                ></file-upload>
              </div>

              <div
                v-if="
                  formData.experimentalResearchType ===
                  'collaborationInResearchGroups'
                "
                class="ml-2"
              >
                <p ref="title" class="mt-4">
                  <b>Colaboração em Grupos de Investigação</b>
                </p>

                <v-text-field
                  v-model="formData.title"
                  type="text"
                  label="Título"
                />

                <v-text-field
                  v-model="formData.researchId"
                  type="text"
                  label="ID"
                />

                <v-text-field
                  v-model="formData.principalInvestigator"
                  type="text"
                  label="Investigador Principal"
                />

                <DatePickerPopUp
                  label="Data inicío"
                  v-model="formData.startDate"
                />

                <DatePickerPopUp label="Data fim" v-model="formData.endDate" />

                <v-text-field
                  v-model="formData.summary"
                  type="text"
                  label="Resumo"
                />

                <p class="mb-2">
                  <b>Resumo</b>
                </p>

                <file-upload
                  :file-url-uploaded.sync="formData.fileUrlAttached"
                  :file-name-uploaded.sync="formData.fileNameAttached"
                  :path-to-files="filepath"
                ></file-upload>
              </div>
            </div>
          </div>

          <div v-if="trainingOfOtherProfessionalsIsSelected">
            <p ref="title" class="mt-4">
              <b>Formação de Outros Profissionais</b>
            </p>

            <span class="caption grey--text text--darken-1">Tipo de Formação</span>
            <v-select
              v-model="formData.otherActivitySubType"
              :items="trainingOfOtherProfessionalsTypes || []"
              solo
              class="thin-border"
            />

            <div v-if="formData.otherActivitySubType === 'medic'" class="ml-2">
              <p ref="title">
                <b>Médicos</b>
              </p>

              <span class="caption grey--text text--darken-1">Instituição</span>
              <v-text-field
                v-model="formData.institution"
                type="text"
                solo
                class="thin-border mb-2"
                hide-details
              />

              <span class="caption grey--text text--darken-1">Caracterização dos Médicos a quem se dirigiu a formação</span>
              <v-text-field
                v-model="formData.characterization"
                type="text"
                solo
                class="thin-border mb-2"
                hide-details
              />

              <span class="caption grey--text text--darken-1">Descrição das actividades</span>
              <v-text-field
                v-model="formData.description"
                type="text"
                solo
                class="thin-border mb-2"
                hide-details
              />
            </div>

            <div
              v-if="formData.otherActivitySubType === 'nonMedic'"
              class="ml-2"
            >
              <p ref="title">
                <b>Não Médicos</b>
              </p>

              <span class="caption grey--text text--darken-1">Tipo</span>
              <v-select
                v-model="formData.nonMedicActivitiesType"
                :items="nonMedicActivitiesTypes || []"
                class="thin-border mb-2"
                solo
                hide-details
              />

              <div
                v-if="formData.nonMedicActivitiesType === 'medicalStudents'"
                class="ml-2"
              >
                <div class="py-3" ref="title">
                  <b >Estudantes de medicina</b>
                </div>

                <span class="caption grey--text text--darken-1">Tipo de formação</span>
                <v-text-field
                  v-model="formData.courseType"
                  type="text"
                  class="thin-border mb-2"
                  solo
                  hide-details
                />

                <DatePickerPopUp
                  label="Data inicío"
                  v-model="formData.startDate"
                />

                <DatePickerPopUp label="Data fim" v-model="formData.endDate" />
              </div>

              <div
                v-if="
                  formData.nonMedicActivitiesType === 'otherHealthProfessionals'
                "
                class="ml-2"
              >
                <p ref="title">
                  <b>Outros Profissionais de Saúde</b>
                </p>

                <span class="caption grey--text text--darken-1">Tipo de formação</span>
                <v-text-field
                  v-model="formData.courseType"
                  type="text"
                  class="thin-border mb-2"
                  solo
                  hide-details
                />

                <span class="caption grey--text text--darken-1">Tipo de profissionais</span>
                <v-text-field
                  v-model="formData.professionalType"
                  type="text"
                  class="thin-border mb-2"
                  solo
                  hide-details
                />

                <span class="caption grey--text text--darken-1">Investigador Principal</span>
                <v-text-field
                  v-model="formData.principalInvestigator"
                  type="text"
                  class="thin-border mb-2"
                  solo
                  hide-details
                />

                <span class="caption grey--text text--darken-1">Descrição das actividades</span>
                <v-text-field
                  v-model="formData.activityDescription"
                  type="text"
                  class="thin-border mb-2"
                  solo
                  hide-details
                />

                <DatePickerPopUp
                  label="Data inicío"
                  v-model="formData.startDate"
                />

                <DatePickerPopUp label="Data fim" v-model="formData.endDate" />
              </div>

              <div
                v-if="
                  formData.nonMedicActivitiesType === 'otherProfessionalGroups'
                "
                class="ml-2"
              >
                <p ref="title">
                  <b>Outros Grupos Profissionais</b>
                </p>

                <span class="caption grey--text text--darken-1">Tipo de Formação</span>
                <v-text-field
                  v-model="formData.courseType"
                  type="text"
                  class="thin-border mb-2"
                  solo
                  hide-details
                />

                <span class="caption grey--text text--darken-1">Tipo de profissionais</span>
                <v-text-field
                  v-model="formData.professionalType"
                  type="text"
                  class="thin-border mb-2"
                  solo
                  hide-details
                />

                <span class="caption grey--text text--darken-1">Descrição das actividades</span>
                <v-text-field
                  v-model="formData.activityDescription"
                  type="text"
                  class="thin-border mb-2"
                  solo
                  hide-details
                />

                <DatePickerPopUp
                  label="Data inicío"
                  v-model="formData.startDate"
                />

                <DatePickerPopUp label="Data fim" v-model="formData.endDate" />
              </div>

              <div
                v-if="formData.nonMedicActivitiesType === 'generalPopulation'"
                class="ml-2"
              >
                <p ref="title">
                  <b>População em geral</b>
                </p>

                <span class="caption grey--text text--darken-1">Tipo de Formação</span>
                <v-text-field
                  v-model="formData.courseType"
                  type="text"
                  class="thin-border mb-2"
                  solo
                  hide-details
                />

                <span class="caption grey--text text--darken-1">Tipo de profissionais</span>
                <v-text-field
                  v-model="formData.professionalType"
                  type="text"
                  class="thin-border mb-2"
                  solo
                  hide-details
                />

                <span class="caption grey--text text--darken-1">Descrição das actividades</span>
                <v-text-field
                  v-model="formData.activityDescription"
                  type="text"
                  class="thin-border mb-2"
                  solo
                  hide-details
                />

                <DatePickerPopUp
                  label="Data inicío"
                  v-model="formData.startDate"
                />

                <DatePickerPopUp label="Data fim" v-model="formData.endDate" />
              </div>
            </div>
          </div>

          <div v-if="teachingActivityIsSelected">
            <p ref="title">
              <b>Actividade Docente</b>
            </p>

            <span class="caption grey--text text--darken-1">Tipo de actividade</span>
            <v-select
              v-model="formData.otherActivitySubType"
              :items="teachingActivityTypes || []"
              class="thin-border mb-2"
              solo
              hide-details
            />

            <div v-if="formData.otherActivitySubType === 'pre'" class="ml-2">
              <p ref="title">
                <b>Pré-graduada</b>
              </p>

              <span class="caption grey--text text--darken-1">Instituição</span>
              <v-text-field
                v-model="formData.institution"
                type="text"
                class="thin-border mb-2"
                solo
                hide-details
              />

              <span class="caption grey--text text--darken-1">Descrição das actividades</span>
              <v-text-field
                v-model="formData.description"
                type="text"
                class="thin-border mb-2"
                solo
                hide-details
              />

              <DatePickerPopUp
                label="Data inicío"
                v-model="formData.startDate"
              />

              <DatePickerPopUp label="Data fim" v-model="formData.endDate" />
            </div>

            <div v-if="formData.otherActivitySubType === 'post'" class="ml-2">
              <p ref="title">
                <b>Pós Graduada</b>
              </p>

              <span class="caption grey--text text--darken-1">Instituição</span>
              <v-text-field
                v-model="formData.institution"
                type="text"
                label="Instituição"
                class="thin-border mb-2"
                solo
                hide-details
              />

              <span class="caption grey--text text--darken-1">Descrição das actividades</span>
              <v-text-field
                v-model="formData.description"
                type="text"
                label="Descrição das actividades"
                class="thin-border mb-2"
                solo
                hide-details
              />

              <DatePickerPopUp
                label="Data inicío"
                v-model="formData.startDate"
              />

              <DatePickerPopUp label="Data fim" v-model="formData.endDate" />
            </div>
          </div>

          <div v-if="professionalAndScientificAssociationsIsSelected">
            <p ref="title">
              <b>Associações Profissionais e Científicas</b>
            </p>

            <span class="caption grey--text text--darken-1">Tipo de actividades</span>
            <v-select
              v-model="formData.otherActivitySubType"
              label="Tipo"
              :items="professionalAndScientificAssociationsTypes || []"
              class="thin-border mb-2"
              solo
              hide-details
            />

            <div
              v-if="formData.otherActivitySubType === 'scientificSocieties'"
              class="ml-2"
            >
              <p ref="title">
                <b>Sociedades Científicas</b>
              </p>

              <span class="caption grey--text text--darken-1">Nome Sociedade</span>
              <v-text-field
                v-model="formData.societyName"
                type="text"
                class="thin-border mb-2"
                solo
                hide-details
              />

              <span class="caption grey--text text--darken-1">Nº Sócio</span>
              <v-text-field
                v-model="formData.memberNo"
                type="text"
                class="thin-border mb-2"
                solo
                hide-details
              />

              <file-upload
                :file-url-uploaded.sync="formData.fileUrlAttached"
                :file-name-uploaded.sync="formData.fileNameAttached"
                :path-to-files="filepath"
              ></file-upload>
            </div>

            <div
              class="ml-2"
              v-if="formData.otherActivitySubType === 'organizations'"
            >
              <p ref="title" class="mt-4">
                <b>Organizações</b>
              </p>

              <span class="caption grey--text text--darken-1">Nome Organização</span>
              <v-text-field
                v-model="formData.organizationName"
                type="text"
                class="thin-border mb-2"
                solo
                hide-details
              />

              <span class="caption grey--text text--darken-1">Nº Sócio</span>
              <v-text-field
                v-model="formData.memberNo"
                type="text"
                class="thin-border mb-2"
                solo
                hide-details
              />

              <file-upload
                :file-url-uploaded.sync="formData.fileUrlAttached"
                :file-name-uploaded.sync="formData.fileNameAttached"
                :path-to-files="filepath"
              ></file-upload>
            </div>
          </div>

          <div v-if="organizationOfScientificEventsIsSelected">
            <p ref="title" class="mt-4">
              <b>Organização de Eventos Científicos</b>
            </p>

            <span class="caption grey--text text--darken-1">Evento</span>
            <v-text-field
              class="thin-border mb-2"
              solo
              hide-details
              v-model="formData.event"
              type="text" />

            <span class="caption grey--text text--darken-1">Função</span>
            <v-text-field
              class="thin-border mb-2"
              solo
              hide-details
              v-model="formData.role"
              type="text"/>

            <span class="caption grey--text text--darken-1">Local</span>
            <v-text-field
              class="thin-border mb-2"
              solo
              hide-details
              v-model="formData.local"
              type="text" />

            <DatePickerPopUp label="Data" v-model="formData.date" />

            <span class="caption grey--text text--darken-1">Resumo</span>
            <v-text-field
              class="thin-border mb-2"
              solo
              hide-details
              v-model="formData.summary"
              type="text"
            />
          </div>

          <div v-if="positionsHeldIsSelected">
            <p ref="title" class="mt-4">
              <b>Cargos Desempenhados</b>
            </p>

            <span class="caption grey--text text--darken-1">Cargo</span>
            <v-text-field
              class="thin-border mb-2"
              solo
              hide-details
              v-model="formData.role"
              type="text" />

            <span class="caption grey--text text--darken-1">Instituição</span>
            <v-text-field
              class="thin-border mb-2"
              solo
              hide-details
              v-model="formData.institution"
              type="text"
            />

            <DatePickerPopUp label="Data inicío" v-model="formData.startDate" />

            <DatePickerPopUp label="Data fim" v-model="formData.endDate" />

            <file-upload
              :file-url-uploaded.sync="formData.fileUrlAttached"
              :file-name-uploaded.sync="formData.fileNameAttached"
              :path-to-files="filepath"
            ></file-upload>
          </div>

          <div v-if="scientificReviewArbitrationIsSelected">
            <p ref="title">
              <b>Revisão Científica</b>
            </p>

            <span class="caption grey--text text--darken-1">Evento / Revista</span>
            <v-text-field
              v-model="formData.eventMagazine"
              type="text"
              class="thin-border mb-2"
              solo
              hide-details
            />

            <span class="caption grey--text text--darken-1">Cargo</span>
            <v-text-field
              class="thin-border mb-2"
              solo
              hide-details
              v-model="formData.role"
              type="text"/>

            <span class="caption grey--text text--darken-1">Descrição</span>
            <v-text-field
              v-model="formData.description"
              type="text"
              class="thin-border mb-2"
              solo
              hide-details
            />

            <DatePickerPopUp label="Data inicío" v-model="formData.startDate" />

            <DatePickerPopUp label="Data fim" v-model="formData.endDate" />

            <span class="caption grey--text text--darken-1">Comentários</span>
            <v-textarea
              v-model="formData.comment"
              solo
              class="thin-border mb-2"
              hide-details
            />
          </div>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-btn
          :loading="loading"
          depressed
          round
          color="secondary"
          @click="submit"
          :disabled="!valid">
          {{ $t('common.Submit') }}
        </v-btn>
        <v-btn
          depressed
          round
          color="gray"
          @click="closeMe">
          {{$t('common.Cancel')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import DatePickerPopUp from '@/components/inputs/DatePickerPopUp'
import { mapActions } from 'vuex'
import FileUpload from '@/components/files/FileUpload'

export default {
  name: 'AddOtherActivityForm',
  components: {
    FileUpload,
    DatePickerPopUp
  },
  props: {
    afterSubmit: {
      required: false,
      type: Function
    },
    closeMe: {
      required: true,
      type: Function
    },
    formData: {
      type: Object
    }
  },
  data() {
    return {
      valid: false,
      loading: false
    }
  },
  computed: {
    postGraduateTrainingIsSelected() {
      return this.formData.otherActivityType === 'postGraduateTraining'
    },
    researchActivitiesIsSelected() {
      return this.formData.otherActivityType === 'researchActivities'
    },
    trainingOfOtherProfessionalsIsSelected() {
      return this.formData.otherActivityType === 'trainingOfOtherProfessionals'
    },
    teachingActivityIsSelected() {
      return this.formData.otherActivityType === 'teachingActivity'
    },
    professionalAndScientificAssociationsIsSelected() {
      return (
        this.formData.otherActivityType ===
        'professionalAndScientificAssociations'
      )
    },
    organizationOfScientificEventsIsSelected() {
      return (
        this.formData.otherActivityType === 'organizationOfScientificEvents'
      )
    },
    positionsHeldIsSelected() {
      return this.formData.otherActivityType === 'positionsHeld'
    },
    scientificReviewArbitrationIsSelected() {
      return this.formData.otherActivityType === 'scientificReviewArbitration'
    },
    experimentalResearchTypes() {
      return [
        {
          text: 'Certificados',
          value: 'certificates'
        },
        {
          text: 'Desenho de Ensaios Clínicos',
          value: 'clinicalTrialDesign'
        },
        {
          text: 'Participação em Ensaios Clínicos',
          value: 'participationInClinicalTrials'
        },
        {
          text: 'Colaboração em Grupos de Investigação',
          value: 'collaborationInResearchGroups'
        }
      ]
    },
    postGraduateTrainingTypes() {
      return [
        {
          text: 'Programa de Doutoramento',
          value: 'doctoralProgram'
        },
        {
          text: 'Curso de Pós-Graduação',
          value: 'graduateCourse'
        },
        {
          text: 'Programa de Mestrado',
          value: 'masterProgram'
        }
      ]
    },
    researchActivitiesTypes() {
      return [
        {
          text: 'Investigação Observacional',
          value: 'observationalResearch'
        },
        {
          text: 'Investigação Experimental',
          value: 'experimentalResearch'
        }
      ]
    },
    trainingOfOtherProfessionalsTypes() {
      return [
        {
          text: 'Médicos',
          value: 'medic'
        },
        {
          text: 'Não médicos',
          value: 'nonMedic'
        }
      ]
    },
    nonMedicActivitiesTypes() {
      return [
        {
          text: 'Estudantes de medicina',
          value: 'medicalStudents'
        },
        {
          text: 'Outros Profissionais de Saúde',
          value: 'otherHealthProfessionals'
        },
        {
          text: 'Outros Grupos Profissionais',
          value: 'otherProfessionalGroups'
        },
        {
          text: 'População em geral',
          value: 'generalPopulation'
        }
      ]
    },
    otherActivityTypes() {
      return [
        {
          text: 'Formação Pós-graduada',
          value: 'postGraduateTraining'
        },
        { text: 'Actividades de Investigação', value: 'researchActivities' },
        {
          text: 'Formação de Outros Profissionais',
          value: 'trainingOfOtherProfessionals'
        },
        { text: 'Actividade Docente', value: 'teachingActivity' },
        {
          text: 'Associações Profissionais e Científicas',
          value: 'professionalAndScientificAssociations'
        },
        {
          text: 'Organização de Eventos Científicos',
          value: 'organizationOfScientificEvents'
        },
        {
          text: 'Cargos Desempenhados',
          value: 'positionsHeld'
        },
        {
          text: 'Revisão Científica',
          value: 'scientificReviewArbitration'
        }
      ]
    },
    professionalAndScientificAssociationsTypes() {
      return [
        {
          text: 'Sociedades Científicas',
          value: 'scientificSocieties'
        },
        {
          text: 'Organizações',
          value: 'organizations'
        }
      ]
    },
    teachingActivityTypes() {
      return [
        {
          text: 'Pré-graduada',
          value: 'pre'
        },
        { text: 'Pós Graduada', value: 'post' }
      ]
    },
    filepath() {
      return `${this.$store.getters.profile.id}/other-activity`
    },
    mandatoryRule() {
      return [v => !!v || this.$t('common.RequiredField')]
    }
  },
  methods: {
    ...mapActions([
      'addOtherActivity',
      'updateOtherActivity',
      'showSuccessSnackbar'
    ]),
    submit() {
      this.loading = true

      if (!this.formData.id) {
        this.formData.userId = this.$store.getters.profile.id
      }

      let action =
        this.formData && this.formData.id
          ? this.updateOtherActivity({ id: this.formData.id, ...this.formData })
          : this.addOtherActivity({ ...this.formData })

      action.then(() => {
        this.closeMe()

        if (this.formData && this.formData.id) {
          this.showSuccessSnackbar('Actividade actualizada com sucesso.')
        } else {
          this.showSuccessSnackbar('Actividade criada com sucesso.')
        }

        if (this.afterSubmit) {
          this.afterSubmit(this.formData)
        }

        this.$refs.form.reset()
        this.loading = false
      })
    }
  }
}
</script>
